'use strict';

/**
 * Инит плгина lozad.js
 * @module
 * @see {@link https://github.com/ApoorvSaxena/lozad.js}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import 'custom-jquery-methods/dist/node-name';

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Добавлеям `lazyLoad` к глобальныму объекту `window`
 */

function attrData (el, name) {
	if (typeof el.data(name) !== 'undefined') {
		el.attr(name, el.data(name));
	}
}

function onLoad ($el) {
	let $parent = $el.parent('.lazy-load');
	if (!$parent.length) {
		$parent = $el;
	}
	$parent.addClass('is-ready').removeClass('is-start');
}

function createLazyLoad () {
	const lozad = require('lozad');
	window.lazyLoad = lozad('.lozad', {
		rootMargin: '100px 0px 100px 0px',
		load (el) {
			let $el = $(el);
			$el.addClass('is-start');
			let src = $el.data('src');
			let img = document.createElement('img');
			let nodeName = $el.nodeName();

			if (nodeName === 'picture') {
				if(!$el.find('img').length) {
					img.onload = () => {
						onLoad($el);
					};
					$el.append(img)
				} else {
					let $parent = $el.parent('.lozad');
					if (!$parent.length) {
						$parent = $el;
					}
					$parent.addClass('is-ready').removeClass('is-start');
				}
			} else {
				img.onload = () => {
					if (nodeName === 'img') {
						attrData($el, 'src');
					} else if (nodeName === 'video') {
						attrData($el, 'poster');
					} else {
						$el.css('background-image', `url(${src})`);
					}
					onLoad($el);
				};
				img.src = src;
			}
		}
	});
	window.lazyLoad.observe();
}

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	if (!$('.lozad').length) {
		return false;
	}

	// если уже `lazyLoad` добавлен вызываем
	if (window.lazyLoad) {
		return window.lazyLoad.observe();
	}

	// иначе добавляем
	if (window.Modernizr.intersectionobserver) {
		createLazyLoad();
	} else {
		// грузим асинхронно полифилл если не поддерживается Intersection Observer
		require.ensure([], () => {
			require('intersection-observer');
			createLazyLoad();
		}, 'intersection-observer-polyfill');
	}
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/lazy-load.js